import { min, max } from 'd3-array';

import Indicator from '../Indicator';
import subpixel from '../util/canvasSubpixelOffset';

/** Rolling Dividend indicator */
export default class RollingDividendIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 */
	_getDefaultParams() {
		return {
			id: 'rollingdividend',
			name: 'Rolling Dividend',
			description: 'The Rolling Dividend chart indicator tracks and visualizes the total dividend payments made by a company over a rolling period.',
			componentSeries: [
				{ id: 'rollingdividend' }
			],
			markerType: 'stepped'
		};
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range minimum
	 */
	getRangeMin(data) {
		return min(data.rollingdividend || [], i => +i.rollingdividend * 0.95);
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range maximum
	 */
	getRangeMax(data) {
		return max(data.rollingdividend || [], i => +i.rollingdividend * 1.05);
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		const dataDividend = this._getDataMap(data.rollingdividend);
		const xScale = this.xScale;
		const yScale = this.yScale;
		const style = this.params.style;
		const ctx = this.panel.rootContext;

		this._renderLineMarker({
			dataMap: dataDividend,
			sessionType,
			isStepped: this.params.markerType === 'stepped'
		});

		// draw final segment to edge of chart
		if (dataDividend.length) {
			const { core } = this;
			const lastDate = core.dataPrimary[core.dataPrimary.length - 1].date;
			const lastIndex = core.closestExchangeIndex(lastDate);
			const lastDividend = dataDividend[dataDividend.length - 1];
			const x0 = xScale(lastDividend[0]);
			const x1 = xScale(lastIndex);
			const y0 = yScale(lastDividend[1]);
			ctx.beginPath();
			ctx.strokeStyle = style.color;
			ctx.lineWidth = style.width;
			if (style.lineDash) {
				ctx.setLineDash(style.lineDash.split(/\s*,\s*/));
			}
			ctx.moveTo(subpixel.px(x0), subpixel.px(y0));
			ctx.lineTo(subpixel.px(x1), subpixel.px(y0));
			ctx.stroke();
			ctx.setLineDash([]);
		}
	}
}
